module.exports = __webpack_public_path__ + "static/media/2fer.cb5a4858.svg";